import { Flow, FlowChunk, FlowFile, FlowOptions } from 'flowjs';
import { FileDTO, FileStatus, FileType, FlowFileUpload } from './TaxAnalyticsClient';
import { ApiClient } from './index';
import { currentToken } from './AADHelper';
const FlowJS = require('@flowjs/flow.js/dist/flow.js');

export const fileStatuses = [
    "Ajouté",
    "Upload en cours",
    "En Pause",
    "Uploadé",
    "Uploadé",
    "Uploadé",
]

export const ToFileDTO = (file: FlowFileUpload, fileType: FileType, status: FileStatus, overrideFileName?: string): FileDTO => {
    const newFile: FileDTO = {
        name: file.flowFilename,
        averageSpeed: 0,
        currentSpeed: 0,
        error: false,
        paused: false,
        relativePath: file.flowRelativePath!,
        size: file.flowTotalSize!,
        uniqueIdentifier: file.flowIdentifier!,
        fileContainerId: file.fileContainerId,
        id: file.id,
        progress: 0,
        creationDate: new Date(),
        isUploading: false,
        status: status,
        type: fileType
    };
    return newFile;
}


const options: FlowOptions = {
    target: '/api/file/add',
    testChunks: true,
    progressCallbacksInterval: 0,
    speedSmoothingFactor: 0.02,
    prioritizeFirstAndLastChunk:true,
    headers: function (file: any, chunk: any, isTest: any) {
        return { Authorization: "Bearer " + currentToken }
    }
}

export const flow: Flow = new FlowJS(options);


export const getFileStatus = (file: FileDTO) => {
    if (fileInterruped(file)) {
        return 'Interrompu';
    }
    if (filePreparing(file)) {
        return 'Préparation';
    }
    return fileStatuses[file.status ?? 0];
}

export const fileInterruped = (file: FileDTO): boolean => {
    var result = !file.paused && !file.isUploading && file.status! < 3 && file.status! !== 0;
    return result;
}

export const filePreparing = (file: FileDTO): boolean => {
    var result = !file.paused && !file.isUploading && file.status! === 0;
    return result;
}

export function SubscribeFlowEvents(name: string, fileType?: FileType, filesAddedCallback?: (uploadedFiles: FlowFileUpload[]) => any, fileProgressCallback?: (uploadedFile: FileDTO) => any) {
    flow.on('filesAdded', function (files, event) {
        const fileContainerId = (flow.opts.query as FlowFileUpload | null)?.fileContainerId;
        files.forEach(f => {
            (f as any).fileSettingId = (event as any).fileSettingId;
        });
        var results = files.find(f => (f as any).fileContainerId === fileContainerId && flow.files.find(ff => (ff as any).name === (f as any).name));
        if (results)
            return false;
    });
    flow.on("fileProgress", function (file: FlowFile, chunk: FlowChunk) {
        UpdateProgress(file, fileType ?? FileType.Input, fileProgressCallback);
    });

    flow.on("fileSuccess", function (file: FlowFile, message: string) {
        UpdateProgress(file, fileType ?? FileType.Input, fileProgressCallback);
    });

    flow.on('filesSubmitted', function (files: FlowFile[], event: Event) {
        const uFiles: FlowFileUpload[] = [];
        files.forEach(file => {
            const opts = (flow.opts.query as any)(file, null, null);
            const uFile: FlowFileUpload = {
                flowFilename: file.name,
                flowTotalSize: file.size,
                flowRelativePath: file.relativePath,
                flowTotalChunks: file.chunks.length,
                flowIdentifier: file.uniqueIdentifier,
                flowChunkSize: 0,
                flowChunkNumber: 0,
                flowCurrentChunkSize: 0,
                status: FileStatus.Added,
                fileContainerId: opts?.fileContainerId,
                fileSettingId: (file as any).fileSettingId,
                orderId: opts?.orderId,
                entityId: opts?.entityId,
                dataAnalysisId: opts?.dataAnalysisId,
                type: fileType,
                itemName: opts?.itemName
            };
            uFiles.push(uFile);
        });
        flow.pause();
        ApiClient.fileClient.create(uFiles).then((files: FlowFileUpload[]) => {
            files?.forEach(p => {
                const flowFile = flow.files.find(f => f.name === p.flowFilename && (flow.opts.query as any)(f, null, null)?.fileContainerId === p.fileContainerId);
                if (flowFile) {
                    (flowFile as any).id = p.id;
                }
            });
            if (filesAddedCallback) {
                filesAddedCallback(files!);
                flow.resume();
            }
        });
        if (filesAddedCallback) {
            filesAddedCallback(uFiles!);
        }
    });

    const dropZone = document.getElementById(name) as any;
    flow.assignDrop(dropZone);
    return function cleanup() {
        flow.off();
        flow.unAssignDrop(dropZone);
    };
}

function UpdateProgress(file: FlowFile, type: FileType, fileUpdatedCallback?: (uploadedFile: FileDTO) => any) {
    if (fileUpdatedCallback) {
        const uFile: FileDTO = {
            averageSpeed: file.averageSpeed,
            currentSpeed: file.currentSpeed,
            error: file.error,
            name: file.name,
            paused: file.paused,
            progress: file.progress() * 100,
            relativePath: file.relativePath,
            size: file.size,
            uniqueIdentifier: file.uniqueIdentifier,
            status: FileStatus.Uploading,
            isUploading: file.isUploading(),
            creationDate: new Date(),
            fileSettingId: (file as any).fileSettingId,
            type: type
        };
        if (file.isComplete()) {
            uFile.status = FileStatus.Completed;
            uFile.progress = 100;
        }
        fileUpdatedCallback(uFile);
    }
}

export function ToggleResumePause(file?: FileDTO, fileUpdatedCallback?: (uploadedFile: FileDTO) => any, reuploadCallback?: (uploadedFile: FileDTO) => void): void {
    if (file) {
        const flowFile = flow.files.find(f => f.uniqueIdentifier === file.uniqueIdentifier);
        if (flowFile) {
            if (flowFile.paused) {
                flowFile.resume();
            }
            else
                flowFile.pause();
            UpdateProgress(flowFile, file.type ?? FileType.Input, fileUpdatedCallback);
        }
        else {
            if (reuploadCallback)
                reuploadCallback(file);
        }
    }
    else {
        if (flow.isUploading())
            flow.pause();
        else
            flow.resume();
    }

}

export function RemoveFile(file: FileDTO, fileRemoveCallback?: (removeFile: FileDTO) => any): void {
    const flowFile = flow.files.find(f => f.uniqueIdentifier === file.uniqueIdentifier);
    if (flowFile) {
        flowFile.cancel();
    }
    if (fileRemoveCallback)
        fileRemoveCallback(file);
    ApiClient.fileClient.delete(file.id);
}